import { useSelector } from "react-redux";

import { Box, CardContent, Typography } from "@mui/material";

import { VSpace } from "components/utility/VSpace";

import { i18n } from "services/i18nService";

import { usePrivileges } from "hooks/usePrivileges";

import { ClearItemCache } from "views/DataUtilities/ClearItemCache";
import { RetrieveFromQbo } from "views/DataUtilities/RetrieveFromQbo";
import { UpdateHistoricalCosts } from "views/DataUtilities/UpdateHistoricalCosts";

import { Forbidden } from "Forbidden";

export function DataUtilities() {
  const connectedToQBO = useSelector(
    (state) => state.userCompanySettings.settings.connectedToQBO
  );

  const { isAdmin } = usePrivileges();

  if (!isAdmin) {
    return <Forbidden />;
  }

  return (
    <>
      <Box sx={{ display: "grid" }} m={2} mb={0}>
        <Box mb={1}>
          <Typography variant="h2">{i18n("dataUtilities.header")}</Typography>
        </Box>
        <Box sx={{ maxWidth: 500 }}>
          <CardContent>
            <ClearItemCache />
            <VSpace space={1.5} />
            <UpdateHistoricalCosts />
            {connectedToQBO && (
              <>
                <VSpace space={1.5} />
                <RetrieveFromQbo />
              </>
            )}
          </CardContent>
        </Box>
        <VSpace space={1} />
      </Box>
    </>
  );
}
